import { useQuery } from "react-query";
import { getOwners } from "../requests/getOwners";

export default function useGetOwners(dealerId: string) {
  return useQuery({
    queryKey: ["dealer", { dealerId }],
    queryFn: () => getOwners(dealerId),
    refetchOnWindowFocus: false,
    enabled: Boolean(dealerId),
  });
}
